import { render } from "./Cbtc.vue?vue&type=template&id=3feb8b26"
import script from "./Cbtc.vue?vue&type=script&lang=js"
export * from "./Cbtc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__